import GameLoop from "slotworks/core/game-loop";
import spinSpammer from "slotworks/debug/menu/spin-spammer";
import DebugTab from "slotworks/debug/menu/tabs/debug-tab";
import SpinTimer from "slotworks/debug/spin-timer";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import StateMachine from "slotworks/state-machine/state-machine";

export default class UtilTab extends DebugTab {

    public render(root: HTMLElement, hide: Function): void {
        this.addFramerateDebugger(root, hide);
        this.addSpeedDebugger(root, hide);
        this.addFPSToggle(root);
        this.addAutoTurbo(root, hide);
        this.addSpinTimer(root);
        this.spamSpin(root);
    }

    private addFramerateDebugger(root: HTMLElement, hide: Function) {
        const inputText = document.createElement("input");
        inputText.type = "text";
        inputText.style.fontSize = "3vw";
        inputText.style.margin = "1vmax 1vw";
        inputText.style.borderRadius = "10px";
        inputText.style.width = "35vw";
        inputText.style.height = "10vmax";
        inputText.style.backgroundColor = "#ffffff";

        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "35vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SET FPS";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            GameLoop.fakeFps = parseInt(inputText.value);
            hide();
        };

        inputText.value = GameLoop.fakeFps.toString();

        root.appendChild(inputText);
        root.appendChild(inputBtn);
    }

    private addSpeedDebugger(root: HTMLElement, hide: Function) {
        const inputText = document.createElement("input");
        inputText.type = "text";
        inputText.style.fontSize = "3vw";
        inputText.style.margin = "1vmax 1vw";
        inputText.style.borderRadius = "10px";
        inputText.style.width = "35vw";
        inputText.style.height = "10vmax";
        inputText.style.backgroundColor = "#ffffff";

        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "35vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SET SPEED";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            GameLoop.speed = parseFloat(inputText.value);
            hide();
        };

        inputText.value = GameLoop.speed.toString();

        root.appendChild(inputText);
        root.appendChild(inputBtn);
    }

    private addFPSToggle(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "TOGGLE FPS";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            GameLoop.toggleStats();
        };
        root.appendChild(inputBtn);
    }

    private addAutoTurbo(root: HTMLElement, hide: Function) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "AUTO TURBO";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            const options: ControlOptions = new ControlOptions();

            options.autoplays.currentValue = Number.POSITIVE_INFINITY;
            options.lossLimit.currentValue = Number.POSITIVE_INFINITY;
            options.singleWinLimit.currentValue = Number.POSITIVE_INFINITY;
            options.stopOnFeatureWin = true;

            options.quickSpin = false;
            options.turboSpin = true;

            AutoplayModel.updateFromOptions(options);
            SettingsModel.updateFromOptions(options);

            SmartUIFlags.set(SmartUIFlag.AUTO_SPIN, true);

            Services.autoplay.start();

            StateMachine.skip();

            hide();
        };
        root.appendChild(inputBtn);
    }

    private addSpinTimer(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SPIN TIMER";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => SpinTimer.toggle();
        root.appendChild(inputBtn);
    }

    private spamSpin(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SPAM SPIN";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => spinSpammer.toggle();
        root.appendChild(inputBtn);
    }
}
